import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AddAddress = () => {
  const { user, token, fetchUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    city_id: '',
    street: '',
    building: '',
    phone: '',
    details: '',
  });

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${API}/cities`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCities(response.data.data);
      } catch (error) {
        console.error('Failed to fetch cities:', error);
      }
    };
    if (token) {
      fetchCities();
    }
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.city_id) {
      toast.error('يرجى اختيار المحافظة');
      return;
    }
    if (!formData.street) {
      toast.error('يرجى إدخال الشارع');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/addresses`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('تمت إضافة العنوان بنجاح');
      
      // Update the user state so addresses are re-fetched
      await fetchUser();

      // Navigate back to where they came from or account
      const from = location.state?.from || '/account';
      navigate(from);
    } catch (error) {
      console.error(error);
      toast.error('حدث خطأ أثناء إضافة العنوان');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <div className="py-12 text-center">يرجى تسجيل الدخول أولاً</div>;
  }

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-tajawal font-bold text-center mb-4">
            إضافة عنوان
          </h1>
          <p className="text-gray-600 text-center mb-8 font-cairo">
            يرجى إضافة عنوان للمتابعة وإتمام طلباتك بشكل صحيح.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>المحافظة *</Label>
              <select
                name="city_id"
                value={formData.city_id}
                onChange={handleChange}
                required
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <option value="">اختر المحافظة...</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <Label>الشارع والحي *</Label>
              <Input
                name="street"
                value={formData.street}
                onChange={handleChange}
                placeholder="مثال: شارع الملك عبدالله، حي الملقا"
                required
              />
            </div>
            
            <div>
              <Label>المبنى / رقم المنزل</Label>
              <Input
                name="building"
                value={formData.building}
                onChange={handleChange}
                placeholder="اختياري"
              />
            </div>
            
            <div>
              <Label>رقم هاتف للعنوان</Label>
              <Input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="اختياري (إذا كان مختلف عن رقمك الأساسي)"
              />
            </div>
            
            <div>
              <Label>تفاصيل إضافية للعنوان</Label>
              <Input
                name="details"
                value={formData.details}
                onChange={handleChange}
                placeholder="مثال: بجوار مسجد النور"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-burgundy-500 hover:bg-burgundy-600 mt-6"
              disabled={loading}
            >
              {loading ? 'جاري الحفظ...' : 'حفظ العنوان'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddAddress;
